import React, { FC } from 'react';
import { Formik, Field } from 'formik';
import ForgetPasswordModal from 'components/Modals/ForgetPasswordModal';
import useLogic from './logic';
import {
  Container,
  Logo,
  ForgetButton,
  Input,
  Button,
  Caption,
  Form,
} from './styles';
import { Props } from './types';

const Login: FC<Props> = ({ login }) => {
  const {
    initialValues,
    validationSchema,
    handleSubmit,
    showModal,
    handleCloseModal,
    handleOpenModal,
    passwordVisability,
    togglePasswordVisability,
  } = useLogic({ login });
  return (
    <Container>
      <Logo />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        <Form noValidate>
          <Field
            name="username"
            as={Input}
            placeholder="Enter your user name"
            label="User name"
          />
          <Field
            type={passwordVisability ? 'text' : 'password'}
            name="password"
            as={Input}
            placeholder="Enter your password"
            label="Password"
            visabilityClickHandler={togglePasswordVisability}
          />
          <ForgetButton type="button" onClick={handleOpenModal}>
            Forget password?
          </ForgetButton>
          <Button fullWidth type="submit">
            Log in
          </Button>
        </Form>
      </Formik>
      <Caption>By logging in you agree to serve amazing food!</Caption>
      <ForgetPasswordModal
        open={showModal}
        handleCloseModal={handleCloseModal}
      />
    </Container>
  );
};

export default Login;

// TODO: TFR-29 add story to component
